import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import './style.css'
import { providesChannelMutations } from 'components/CloneChannel/dataSync'
import { templateChannels } from './constants'
import classNames from 'classnames'
import ModalWrapper from 'components/Utils/Modal/Wrapper'
import ModalBody from 'components/Utils/Modal/Body'
import * as modalIds from 'components/Utils/Modal/constants'
import * as Icons from 'components/Utils/Icons'
import { Button, Text } from 'components/base'
import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'
import { setActiveModal } from 'data/ui/actions'

class ChannelOnboarding extends Component {
  static propTypes = {
    cloneChannel: PropTypes.func.isRequired,
  }

  state = {
    channelsSelected: [],
  }

  onChannelSelection(name) {
    if (this.state.channelsSelected.includes(name)) {
      this.setState({
        channelsSelected: this.state.channelsSelected.filter(
          channel => channel !== name
        ),
      })
    } else {
      this.setState({
        channelsSelected: this.state.channelsSelected.concat(name),
      })
    }
  }

  onValidate = channels => {
    const { onModalClose, cloneChannel, updateUserPreferences } = this.props

    channels.forEach(channel => {
      if (this.state.channelsSelected.includes(channel.name)) {
        cloneChannel({
          publicShareToken: channel.token,
          type: 'public',
          name: channel.name,
        })
      }
    })
    updateUserPreferences({ isChannelOnboardingDone: true })
    onModalClose()
  }

  onClose = () => {
    const { onModalClose, updateUserPreferences } = this.props
    updateUserPreferences({ isChannelOnboardingDone: true })
    onModalClose()
  }

  onSkip = () => {
    const { setActiveModal, updateUserPreferences } = this.props
    setActiveModal({ id: modalIds.CHANNEL_CREATE })
    updateUserPreferences({ isChannelOnboardingDone: true })
  }

  renderChannel(channel) {
    const isSelected = this.state.channelsSelected.includes(channel.name)
    return (
      <div
        style={{ position: 'relative' }}
        className="channel-template margin-horizontal-large"
        key={channel.name}
      >
        <div
          style={{
            position: 'absolute',
            top: '-12px',
            right: '-12px',
            display: 'inline-flex',
          }}
          className={classNames(
            isSelected ? 'background-green' : 'select-icon background-shade-30',
            'padding-small radius-normal shade-100'
          )}
        >
          {isSelected ? (
            <Icons.CheckMarkIcon size={12} />
          ) : (
            <Icons.PlusIcon size={12} />
          )}
        </div>
        <div
          onClick={() => this.onChannelSelection(channel.name)}
          className={classNames(
            'border-small radius-normal pointer flexbox flexbox-column flexbox-align-center padding-horizontal-large',
            isSelected
              ? 'border-green'
              : 'channel-template-inner border-shade-40 border-primary-on-hover'
          )}
        >
          <span className="margin-vertical-large shade-10">{channel.name}</span>
          <img
            src={channel.image}
            alt="People pointing at things"
            width="180"
            height="200"
          />
        </div>
      </div>
    )
  }

  renderContent() {
    return (
      <ModalBody>
        <Text.Title className="margin-bottom-normal">
          Let's create your first channel
        </Text.Title>
        <Text.Corpus className="margin-bottom-larger">
          <span className="black font-weight-medium">
            Start in a flash with templates made just for you!
            <br />
          </span>
          <span className="shade-05">
            Channels let you organize your teamwork and handle members
            permissions.
          </span>
        </Text.Corpus>
        <div className="flexbox flexbox-centered">
          {templateChannels.map(channel => this.renderChannel(channel))}
        </div>
        <div className="flexbox flexbox-column flexbox-centered">
          <Button.Primary
            onClick={() => this.onValidate(templateChannels)}
            disabled={!this.state.channelsSelected.length}
            className="margin-top-largest margin-bottom-medium font-weight-bold"
          >
            Create new channels
          </Button.Primary>
          <Text.Action onClick={this.onSkip}>or start from scratch</Text.Action>
        </div>
      </ModalBody>
    )
  }

  render() {
    return (
      <ModalWrapper wide onClose={this.onClose}>
        {this.renderContent()}
      </ModalWrapper>
    )
  }
}

const mapDispatchToProps = {
  setActiveModal,
}

export default compose(
  providesChannelMutations,
  providesUserPreferencesMutations,
  connect(
    null,
    mapDispatchToProps
  )
)(ChannelOnboarding)
